const versionConfig = require('@/version.config.json')

export const contentTpl = {
  components: {
    BaseContentBlock: () => import('@/base/BaseContentBlock.vue')
  },
  mounted() {
    document.title = this.metaTitle
  },
  computed: {
    title() {
      return this.$route.meta.title ? this.$route.meta.title : ''
    },
    projectTitle() {
      return versionConfig.name
    },
    metaTitle() {
      const title = this.$route.meta.metaTitle ? this.$route.meta.metaTitle : this.title
      return title + ' ' + this.projectTitle
    }
  }
}
